function createSession() {
  return {
    weekday: 0,
    startTime: '19:00',
    maxSize: 10,
  };
}

export default createSession;
